import { isObject } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
const ENGINE_ON_ATTRIBUTE_KEY = 'ENGINE_ON'
const MOVEMENT_ATTRIBUTE_KEY = 'MOVEMENT'
export default {
  name: 'basicInfo',

  data () {
    return {
      visibleFields: {
        engineOnAttribute: false,
        movementAttribute: false
      }
    }
  },

  computed: {
    basicInfoEditConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'satellite-tracking',
            route: `trip-configuration/${this.resolveRouteParamValue('id')}`
          },
          post: {
            module: 'satellite-tracking',
            route: `trip-configuration/${this.resolveRouteParamValue('id')}`
          }
        },
        dataFetched: (event) => this.onBasicInfoDataFetched(event),
        afterCancel: (event) => this.onBasicInfoDataFetched(event),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base/user.basic_info'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView('TripConfiguration')
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'description',
                    label: this.$t('satellite-tracking/trip_configuration.description'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_min_distance',
                    label: this.$t('satellite-tracking/trip_configuration.trip_min_distance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_min_duration',
                    label: this.$t('satellite-tracking/trip_configuration.trip_min_duration'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_min_pause_duration',
                    label: this.$t('satellite-tracking/trip_configuration.trip_min_pause_duration'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_end_delay',
                    label: this.$t('satellite-tracking/trip_configuration.trip_end_delay'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'force_can_distance',
                    label: this.$t('satellite-tracking/trip_configuration.force_can_distance'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_use_engine_on',
                    label: this.$t('satellite-tracking/trip_configuration.trip_use_engine_on'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true,
                    onChange: (value) => this.onEngineOnChange(value)
                  },
                  {
                    key: 'engine_on_attribute',
                    label: this.$t('satellite-tracking/trip_configuration.engine_on_attribute'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'satellite-tracking',
                      route: 'trip-config-attribute/autocomplete',
                      custom_display_value: (event) => {
                        return event?.description
                      },
                      queryParams: {
                        type: ENGINE_ON_ATTRIBUTE_KEY
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: this.visibleFields.engineOnAttribute
                  },
                  {
                    key: 'trip_use_movement',
                    label: this.$t('satellite-tracking/trip_configuration.trip_use_movement'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true,
                    onChange: (value) => this.onUseMovementChange(value)
                  },
                  {
                    key: 'movement_attribute',
                    label: this.$t('satellite-tracking/trip_configuration.movement_attribute'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'satellite-tracking',
                      route: 'trip-config-attribute/autocomplete',
                      custom_display_value: (event) => {
                        return event?.description
                      },
                      queryParams: {
                        type: MOVEMENT_ATTRIBUTE_KEY
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: this.visibleFields.movementAttribute
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onEngineOnChange (value) {
      this.visibleFields.engineOnAttribute = !!value
    },

    onUseMovementChange (value) {
      this.visibleFields.movementAttribute = !!value
    },

    onBasicInfoDataFetched (event) {
      const { data } = event?.data || {}
      const { formDataForSend } = event || {}
      const dataResult = data || formDataForSend

      if (!dataResult || !isObject(dataResult)) {
        return
      }

      this.visibleFields.engineOnAttribute = !!dataResult.trip_use_engine_on
      this.visibleFields.movementAttribute = !!dataResult.trip_use_movement
    }
  }
}
